import { PkgWarehouse } from '@/api/user-package/types/UserPkg'

import { PriceChart, priceChartGR, priceChartUK, priceChartUSA } from './priceChart'

export const binarySearchClosestValue = (key: number, country: PkgWarehouse | string) => {
  let arr: PriceChart[]
  switch (country) {
    case 'GR':
      arr = priceChartGR
      break
    case 'USA':
      arr = priceChartUSA
      break
    case 'UK':
      arr = priceChartUK
      break
    default:
      arr = priceChartGR
  }
  return findClosest(key, arr)
}

function findClosest(target: number, arr: PriceChart[]) {
  const n = arr.length
  if (target <= arr[0].weight) {
    return arr[0].price
  }
  if (target >= arr[n - 1].weight) {
    return arr[n - 1].price
  }

  let i = 0
  let j = n - 1
  let mid = 0

  while (i < j) {
    mid = Math.floor((i + j) / 2)

    if (arr[mid].weight === target) {
      return arr[mid].price
    } else if (target < arr[mid].weight) {
      if (mid > 0 && target > arr[mid - 1].weight) {
        return getClosest(arr[mid - 1], arr[mid], target)
      }
      j = mid
    } else {
      if (mid < n - 1 && target < arr[mid + 1].weight) {
        return getClosest(arr[mid], arr[mid + 1], target)
      }
      i = mid + 1
    }
  }
  return arr[mid].price
}

function getClosest(obj1: PriceChart, obj2: PriceChart, target: number) {
  if (target - obj1.weight > target - obj2.weight) {
    return obj2.price
  } else {
    return obj1.price
  }
}
